// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DAY = "De\u0148";
export const MONTH = "Mesiac";
export const YEAR = "Rok";
export const YOU_DID_NOT_ENTER_VALID_DATE = "Nezadala si platn\u00fd d\u00e1tum.";
